export default __webpack_public_path__ + "static/header-94881d18b82dd382c974aca051ef6933.png";